import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import RateListPanel from '../../data_hub/RateListPanel';
import RateDetailPanel from '../../data_hub/RateDetailPanel';

/**
 * UtilityRatePickerDrawer - Modal drawer for selecting utility rates
 * @param {boolean} isOpen - Whether the drawer is open
 * @param {Function} onClose - Callback when drawer is closed
 * @param {Function} onSelectRate - Callback when a rate is selected: (rateData) => void
 */
const UtilityRatePickerDrawer = ({ isOpen, onClose, onSelectRate }) => {
  const [selectedRateId, setSelectedRateId] = useState(null);

  const handleRateClick = (rateSummary) => {
    setSelectedRateId(rateSummary.id);
  };

  const handleUseRate = (rateData) => {
    if (onSelectRate) {
      onSelectRate(rateData);
    }
    onClose();
  };

  const handleClose = () => {
    setSelectedRateId(null);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity"
        onClick={handleClose}
      />
      
      {/* Drawer */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-2xl w-full max-w-7xl h-[90vh] flex flex-col overflow-hidden">
          {/* Header */}
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-gray-50">
            <div>
              <h2 className="text-2xl font-bold text-gray-800 font-ui">Select Utility Rate</h2>
              <p className="text-sm text-gray-600 mt-1">Browse rates from the Datahub database</p>
            </div>
            <button
              onClick={handleClose}
              className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-200 rounded-md transition-colors"
              title="Close"
            >
              <FaTimes className="text-xl" />
            </button>
          </div>

          {/* Content - Two Column Layout */}
          <div className="flex-1 flex overflow-hidden">
            {/* Left Panel - Rate List */}
            <div className="w-1/2 border-r border-gray-200 p-4 overflow-hidden">
              <RateListPanel
                onSelectRate={handleRateClick}
                selectedRateId={selectedRateId}
                compact={true}
              />
            </div>

            {/* Right Panel - Rate Detail */}
            <div className="w-1/2 overflow-hidden">
              <RateDetailPanel
                rateId={selectedRateId}
                onUse={handleUseRate}
                showUseButton={true}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UtilityRatePickerDrawer;
